<script setup>
import {computed, ref, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import Button from "@/common/Button.vue"
import {usePageEditorStore} from '@/stores/pageEditor'
import {useItemDataStore} from '@/stores/itemData'
import {useSiteTreeStore} from '@/stores/siteTree'

const route = useRoute()
const router = useRouter()
const pageEditorStore = usePageEditorStore()
const itemDataStore = useItemDataStore()

const pageId = computed(() => pageEditorStore.pageId)
const siteTreeId = computed(() => pageEditorStore.siteTreeId)
const siteTreeStore = computed(() => siteTreeId.value ? useSiteTreeStore(siteTreeId.value) : null)

const page = ref(null)

watch(pageId, async (newId) => {
    if (newId) {
        page.value = await itemDataStore.get({
            tableName: 'pages',
            id: newId
        })
    } else {
        page.value = null
    }
}, {immediate: true})

const selectPage = async () => {
    if (Number(route.params.pageId) !== pageId.value || Object.keys(route.params).length > 1) {
        await router.push({name: 'pageEditor', params: {pageId: pageId.value}, query: null})
    }

    if (siteTreeStore.value) {
        await siteTreeStore.value.setPageId(pageId.value)
    }

    pageEditorStore.leftSidebarActiveTab = 'Site tree'
}
</script>

<template>
    <Button v-if="page" class="btn-sm lh-1 p-1" type="button" @click="selectPage">
        <small>{{ page.title }}</small>
    </Button>
</template>